import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faArrowDown,
  faArrowUp,
  faBell,
  faBolt,
  faBookOpen,
  faCalendarAlt,
  faChartLine,
  faChevronLeft,
  faChevronRight,
  faChild,
  faClipboardCheck,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEye,
  faEyeSlash,
  faFileAlt,
  faHandHoldingHeart,
  faHome,
  faInfoCircle,
  faList,
  faLock,
  faMapMarkerAlt,
  faMobileAlt,
  faPlay,
  faPlus,
  faRefresh,
  faSchool,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faSignOutAlt,
  faTrash,
  faUsers,
  faWifi,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAddressBook,
  faArrowDown,
  faArrowUp,
  faBell,
  faBolt,
  faBookOpen,
  faCalendarAlt,
  faChartLine,
  faChevronLeft,
  faChevronRight,
  faChild,
  faClipboardCheck,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEye,
  faEyeSlash,
  faFileAlt,
  faHandHoldingHeart,
  faHome,
  faInfoCircle,
  faList,
  faLock,
  faMapMarkerAlt,
  faMobileAlt,
  faPlay,
  faPlus,
  faRefresh,
  faSchool,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faSignOutAlt,
  faTrash,
  faUsers,
  faWifi,
  faXmark,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
